import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryList: [],
};

const categoryListSlice = createSlice({
  name: "categorylist",
  initialState: initialState,
  reducers: {
    setCategoryList(state, action) {
      state.categoryList = action.payload;
    },
    appendCategoryList: (state, action) => {
      state.categoryList = [...state.categoryList, ...action.payload];
    },
    clearCategoryList: (state) => {
      state.categoryList = [];
    },
  },
});

export const { setCategoryList, appendCategoryList, clearCategoryList } =
  categoryListSlice.actions;
export default categoryListSlice.reducer;
